export default "__VITE_ASSET__0upCeXm1__"